import { render, staticRenderFns } from "./AccessoriesItem.vue?vue&type=template&id=6eeeb4e0&scoped=true&"
import script from "./AccessoriesItem.vue?vue&type=script&lang=js&"
export * from "./AccessoriesItem.vue?vue&type=script&lang=js&"
import style0 from "./AccessoriesItem.vue?vue&type=style&index=0&id=6eeeb4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeeb4e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VImg,VRow})
